module.exports = __webpack_public_path__ + "img/juan_gonzalez.91fc3315.png";